import { EInstitutionType } from '@ucheba/store/institutions/item/types'

export const dictionary = {
  title: {
    [EInstitutionType.University]: 'вуз',
    [EInstitutionType.College]: 'колледж',
  },
}
